import type { DataTypes } from 'fitify-ui-landing/src/@types'
import { ContentRevealAnimation } from 'fitify-ui-landing/src/components/animations/ContentRevealAnimation'
import NativeImage from 'fitify-ui-landing/src/components/Image/NativeImage'
import Section from 'fitify-ui-landing/src/components/Section/Section'
import { Text } from 'fitify-ui-landing/src/components/Text'
import { useTranslation } from 'next-i18next'

import Review from '@/components/blocks/Reviews/Review'
import Container from '@/components/Container/Container'
import { reviewCommunityData } from '@/data/reviews'

import {
  StyledReviewsWrapper,
  StyledReviewsTitle,
  StyledSubtitle,
  StyledHeadingContainer,
  StyledNativeImageWrapperDesktop,
  StyledNativeImageWrapperMobile,
  StyledReviewsContainer,
} from './Reviews.Styled'

const Reviews = ({
  headline,
  items,
}: {
  headline: string
  items: DataTypes.ReviewItem[]
}) => {
  const { t } = useTranslation()

  return (
    <Section id={'reviews'}>
      <Container>
        <StyledReviewsContainer>
          <ContentRevealAnimation>
            <StyledHeadingContainer>
              <StyledReviewsTitle>
                <Text
                  as={'h2'}
                  style={{ margin: 0 }}
                  variant={'business-title'}
                >
                  {headline}
                </Text>
              </StyledReviewsTitle>
              <StyledNativeImageWrapperMobile>
                <NativeImage
                  alt={reviewCommunityData.alt}
                  src={reviewCommunityData.imageSrc}
                  srcSet={reviewCommunityData.imageSrcSet}
                  width={'100%'}
                  height={'auto'}
                />
              </StyledNativeImageWrapperMobile>
              <StyledNativeImageWrapperDesktop>
                <NativeImage
                  alt={reviewCommunityData.alt}
                  src={reviewCommunityData.imageSrc}
                  srcSet={reviewCommunityData.imageSrcSet}
                  width={'100%'}
                  height={'auto'}
                />
              </StyledNativeImageWrapperDesktop>
              <StyledSubtitle
                dangerouslySetInnerHTML={{
                  __html: t('cl_landing_meals_scanned_label'),
                }}
              />
            </StyledHeadingContainer>

            <StyledReviewsWrapper>
              {items.map((item, index: number) => {
                return (
                  <Review
                    key={index}
                    name={item.name}
                    job={item.job}
                    description={item.description}
                  />
                )
              })}
            </StyledReviewsWrapper>
          </ContentRevealAnimation>
        </StyledReviewsContainer>
      </Container>
    </Section>
  )
}

export default Reviews
